import { createHead } from '@unhead/vue/client';
import { setLocale as setMacroLocale, untilLocale } from 'macro-i18n';

import { setLocale } from '@/context';
import { ComponentError } from '@/core/component-error';

import { createApp, isSilentError } from './app';

(async () => {
  const base = ((base) => (/^[a-z]{2}-[A-Z]{2}$/.test(base) ? base : ''))(
    window.location.pathname.split('/')[1],
  );
  const lang = document.documentElement.getAttribute('lang') || base;

  const locale = lang || 'en-GB';
  await Promise.all([setLocale(locale), setMacroLocale(locale)]);

  const { app, router } = await createApp(
    {
      locale,
      base: base && base === lang ? '/' + base : undefined,
    },
    document.documentElement.getAttribute('hydrate') === null,
  );

  const head = createHead();
  app.use(head);

  window.addEventListener('error', (ev) => {
    const { error: err } = ev;
    ev.preventDefault();

    if (isSilentError(err)) return;

    router.currentRoute.value.meta.error = err;
  });

  window.addEventListener('unhandledrejection', (ev) => {
    const { reason: err } = ev;

    if (isSilentError(err)) return;

    router.currentRoute.value.meta.error = err;
  });

  app.config.errorHandler = (err, instance, info) => {
    if (isSilentError(err)) return;

    router.currentRoute.value.meta.error = new ComponentError(
      err,
      instance,
      info,
    );
  };

  router.beforeEach(async (_to, _from, next) => {
    await untilLocale();

    console.log('untilLocale');

    next();
  });

  await router.isReady();

  app.mount('#app');
})();
